//citationFormats.js
import { mapPublicationData } from "./mapPublication";
// --- YAZAR FONKSİYONLARI ---

// APA için: "Ünal, H., Şafak, C."
function getAPAAuthors(authorsArr) {
  if (!authorsArr || !authorsArr.length) return "";

  const formatUser = (a) => {
    if (a.isSingleName) return a.name; // "İmam Rabbani"
    return `${a.surname}, ${a.name[0]}.`; // "Ünal, H."
  };

  if (authorsArr.length === 1) return formatUser(authorsArr[0]);

  const lastAuthor = authorsArr[authorsArr.length - 1];
  const otherAuthors = authorsArr.slice(0, -1);

  return otherAuthors.map(formatUser).join(", ") + ` & ${formatUser(lastAuthor)}`;
}
// MLA için: "Ünal, Halime and Şafak, Cem"
// 3+ için "Ünal, Halime, et al."
function getMLAAuthors(authorsArr) {
  if (!authorsArr || !authorsArr.length) return "";
  const formatUser = (a, reverse = false) => {
    if (a.isSingleName) return a.name;
    return reverse ? `${a.surname}, ${a.name}` : `${a.name} ${a.surname}`;
  };

  if (authorsArr.length === 1) return formatUser(authorsArr[0], true);
  if (authorsArr.length === 2)
    return `${authorsArr[0].surname}, ${authorsArr[0].name} and ${authorsArr[1].surname}, ${authorsArr[1].name}`;
  // 3+ yazar için
  return `${authorsArr[0].surname}, ${authorsArr[0].name}, et al.`;
}

// IEEE için: "H. Ünal, C. Şafak"
function getIEEEAuthors(authorsArr) {
  if (!authorsArr || !authorsArr.length) return "";
  return authorsArr.map(a => {
    if (a.isSingleName) return a.name;
    return `${a.name[0]}. ${a.surname}`;
  }).join(", ");
}

// Harvard için: "Ünal, H. and Şafak, C." / çoksa "Ünal, H. et al."
function getHarvardAuthors(authorsArr) {
  if (!authorsArr || !authorsArr.length) return "";

  return authorsArr
    .map((a, i) => {
      // Sonuncu yazar "and" ile yazılır
      if (i === authorsArr.length - 1 && authorsArr.length > 1) {
        return `and ${a.surname}, ${a.name[0]}.`;
      }
      return `${a.surname}, ${a.name[0]}.`;
    })
    .join(", ");
}

// APA 7
export function generateAPA(pub) {
  const d = mapPublicationData(pub);
  const authorStr = getAPAAuthors(d.authorsArr);

  // DOI varsa link formatında ekle (Görseldeki örneğe uygun)
  const doiStr = d.doi ? ` https://doi.org/${d.doi}` : "";

  // 1. Makale
  if (d.type.includes("Makale")) {
    // Dergi adı ve Cilt italik olur
    return `${authorStr} (${d.year}). ${d.title}. <em>${d.journal}</em>${d.volume ? `, <em>${d.volume}</em>` : ""}${d.issue ? `(${d.issue})` : ""}${d.pages ? `, ${d.pages}` : ""}.${doiStr}`;
  }

  // 2. Kitap Bölümü veya Konferans Bildirisi (Tam Metin/Proceedings)
  // Armağan kitapları da genelde "Bölüm" mantığıyla çalışır.
  if (d.type.includes("Bölüm") || (d.type.includes("Konferans") && d.type.includes("Yazı"))) {
    // Format: Author (Year). Title. In Editor (Ed.), BookTitle (pp. xx-xx). Publisher.

    let containerStr = "In ";

    // Editör varsa ekle: "A. Editör (Ed.), "
    if (d.editor) {
      // Editör ismini kontrol et, çoklu ise (Eds.) yap
      const edSuffix = (d.editor.includes("&") || d.editor.includes(" ve ")) ? "(Eds.)" : "(Ed.)";
      containerStr += `${d.editor} ${edSuffix}, `;
    }

    // Kitap/Konferans Adı İtalik
    containerStr += `<em>${d.bookTitle || d.confName}</em>`;

    // Sayfa numaraları parantez içinde: (pp. 107-121)
    if (d.pages) {
      containerStr += ` (pp. ${d.pages})`;
    }

    return `${authorStr} (${d.year}). ${d.title}. ${containerStr}. ${d.publisher}.${doiStr}`;
  }

  // 3. Konferans Sunumu (Sadece sunum, bildiri kitabında basılmamışsa)
  if (d.type.includes("Konferans") && !d.type.includes("Yazı")) {
    return `${authorStr} (${d.year}). ${d.title}. ${d.confName}${d.city ? `, ${d.city}` : ""}.`;
  }

  // 4. Kitap (Tamamı)
  if (d.type.includes("Kitap") && !d.type.includes("Bölüm")) {
    return `${authorStr} (${d.year}). <em>${d.title}</em>${d.editor ? ` (${d.editor}, Ed.)` : ""}. ${d.publisher}.${doiStr}`;
  }

  return "";
}

// MLA 9
export function generateMLA(pub) {
  const d = mapPublicationData(pub);
  const authorStr = getMLAAuthors(d.authorsArr);

  const pages = d.pages ? `, pp. ${d.pages}` : "";

  if (d.type.includes("Makale")) {
    return `${authorStr}. "${d.title}." ${d.journal}${d.volume ? `, vol. ${d.volume}` : ""}${d.issue ? `, no. ${d.issue}` : ""}, ${d.year}${pages}.`;
  }

  if (d.type.includes("Konferans")) {
    return `${authorStr}. ${d.title}. ${d.year}.`;
  }

  if (d.type.includes("Kitap") && !d.type.includes("Bölüm")) {
    return `${authorStr}. ${d.title}.${d.editor ? ` Edited by ${d.editor},` : ""} ${d.publisher}, ${d.year}.`;
  }

  if (d.type.includes("Bölüm")) {
    return `${authorStr}. "${d.title}." ${d.bookTitle}${d.editor ? `, edited by ${d.editor}` : ""}, ${d.publisher}, ${d.year}${pages}.`;
  }

  return "";
}

// CHICAGO
export function generateChicago(pub) {
  const d = mapPublicationData(pub);

  const pages = d.pages ? `, ${d.pages}` : "";

  if (d.type.includes("Makale")) {
    return `${d.authors}. "${d.title}." ${d.journal} ${d.volume ? d.volume : ""}${d.issue ? `, no. ${d.issue}` : ""} (${d.year})${pages}.`;
  }

  if (d.type.includes("Konferans")) {
    return `${d.authors}. “${d.title},” ${d.year}.`;
  }

  if (d.type.includes("Kitap") && !d.type.includes("Bölüm")) {
    return `${d.authors}. ${d.title}.${d.editor ? ` Edited by ${d.editor}.` : ""} ${d.publisher}, ${d.year}.`;
  }

  if (d.type.includes("Bölüm")) {
    return `${d.authors}. “${d.title}.” In ${d.bookTitle}${d.editor ? `, edited by ${d.editor}` : ""}, ${d.publisher}, ${d.year}${pages}.`;
  }

  return "";
}

// VANCOUVER
export function generateVancouver(pub) {
  const d = mapPublicationData(pub);

  const pages = d.pages ? ` p. ${d.pages}.` : ".";

  if (d.type.includes("Makale")) {
    return `${d.authors}. ${d.title}. ${d.journal}. ${d.year};${d.volume ? d.volume : ""}${d.issue ? `(${d.issue})` : ""}${pages}`;
  }

  if (d.type.includes("Kitap") && !d.type.includes("Bölüm")) {
    return `${d.authors}. ${d.title}. ${d.editor ? `${d.editor}, editor. ` : ""}${d.publisher}; ${d.year}.`;
  }

  if (d.type.includes("Bölüm")) {
    return `${d.authors}. ${d.title}. In: ${d.bookTitle}. ${d.publisher}; ${d.year}.${pages}`;
  }

  if (d.type.includes("Konferans")) {
    return `${d.authors}. ${d.title}. ${d.year}.`;
  }

  return "";
}

// HARVARD
export function generateHarvard(pub) {
  const d = mapPublicationData(pub);
  const authorStr = getHarvardAuthors(d.authorsArr);

  const pages = d.pages ? `, pp. ${d.pages}` : "";

  if (d.type.includes("Makale")) {
    return `${authorStr} (${d.year}). ${d.title}. ${d.journal}, ${d.volume ? d.volume : ""}${d.issue ? `(${d.issue})` : ""}${pages}.`;
  }

  if (d.type.includes("Kitap") && !d.type.includes("Bölüm")) {
    return `${authorStr} (${d.year}) ${d.title}. ${d.publisher}.`;
  }

  if (d.type.includes("Bölüm")) {
    return `${authorStr} (${d.year}) ${d.title}. In: ${d.bookTitle}${pages}. ${d.publisher}.`;
  }

  if (d.type.includes("Konferans")) {
    return `${authorStr} (${d.year}) ${d.title}. In: ${d.confName}.`;
  }

  return "";
}



// IEEE
export function generateIEEE(pub) {
  const d = mapPublicationData(pub);
  const firstInitials = d.authorsArr.map(a => `${a.name[0]}. ${a.surname}`).join(", ");

  const pages = d.pages ? `, pp. ${d.pages}` : "";

  if (d.type.includes("Makale")) {
    return `${firstInitials}, "${d.title}," in ${d.journal}${d.volume ? `, vol. ${d.volume}` : ""}${d.issue ? `, no. ${d.issue}` : ""}${pages}, ${d.year}.`;
  }

  if (d.type.includes("Kitap") && !d.type.includes("Bölüm")) {
    return `${firstInitials}, ${d.title}.${d.editor ? ` Edited by ${d.editor}.` : ""} ${d.publisher}, ${d.year}.`;
  }

  if (d.type.includes("Bölüm")) {
    return `${firstInitials}, "${d.title}," in ${d.bookTitle}${d.editor ? `, edited by ${d.editor}` : ""}${pages}, ${d.publisher}, ${d.year}.`;
  }

  if (d.type.includes("Konferans")) {
    return `${firstInitials}, "${d.title}," presented at the ${d.confName}, ${d.year}.`;
  }

  return "";
}

function bibField(label, value) {
  if (!value) return "";
  return `  ${label} = {${value}},\n`;
}

export function generateBibTeX(pub) {
  const d = mapPublicationData(pub);

  // BibTeX'te yazarları işlerken:
  const bibAuthors = d.authorsArr.map(a => {
    if (a.isSingleName) return `{${a.name}}`; // Süslü parantez BibTeX'in parçalamasını engeller
    return `${a.surname}, ${a.name}`;
  }).join(" and ");

  // @article (Popüler Dergi Yazısı ve Akademik Makale)
  if (d.type.toLowerCase().includes("makale") || d.type.toLowerCase().includes("yazısı")) {
    let str = `@article{${(d.authorsArr?.[0]?.surname || "author").toLowerCase()}${d.year},\n`;
    str += bibField("author", bibAuthors);
    str += bibField("title", d.title);
    str += bibField("journal", d.journal);
    str += bibField("year", d.year);
    str += bibField("volume", d.volume);
    str += bibField("number", d.issue);
    str += bibField("pages", d.pages);
    str += bibField("issn", d.issn);
    str += bibField("doi", d.doi);
    str += bibField("publisher", d.publisher); // bazen dergiyi basan yayinevi de olabilir
    str = str.trim().replace(/,$/, ""); // sonda virgül olmasın
    return str + "\n}";
  }
  // @book (Popüler/akademik kitap)
  if (d.type.toLowerCase().includes("kitap") && !d.type.toLowerCase().includes("bölüm")) {
    let str = `@book{${(d.authorsArr?.[0]?.surname || "author").toLowerCase()}${d.year},\n`;
    str += bibField("author", d.authors);
    str += bibField("title", d.title);
    str += bibField("publisher", d.publisher);
    str += bibField("year", d.year);
    str += bibField("editor", d.editor);
    str += bibField("isbn", d.isbn);
    str = str.trim().replace(/,$/, "");
    return str + "\n}";
  }
  // @incollection (kitap bölümü)
  if (d.type.toLowerCase().includes("bölüm")) {
    let str = `@incollection{${(d.authorsArr?.[0]?.surname || "author").toLowerCase()}${d.year},\n`;
    str += bibField("author", d.authors);
    str += bibField("title", d.title);
    str += bibField("booktitle", d.bookTitle);
    str += bibField("publisher", d.publisher);
    str += bibField("year", d.year);
    str += bibField("editor", d.editor);
    str += bibField("pages", d.pages);
    str += bibField("isbn", d.isbn);
    str = str.trim().replace(/,$/, "");
    return str + "\n}";
  }
  // @inproceedings (konferans/armağan)
  if (d.type.toLowerCase().includes("konferans")) {
    let str = `@inproceedings{${(d.authorsArr?.[0]?.surname || "author").toLowerCase()}${d.year},\n`;
    str += bibField("author", d.authors);
    str += bibField("title", d.title);
    str += bibField("booktitle", d.bookTitle || d.confName); // proceedings title
    str += bibField("publisher", d.publisher);
    str += bibField("year", d.year);
    str += bibField("editor", d.editor);
    str += bibField("pages", d.pages);
    str += bibField("doi", d.doi);
    str = str.trim().replace(/,$/, "");
    return str + "\n}";
  }
  // fallback
  let str = `@misc{${(d.authorsArr?.[0]?.surname || "author").toLowerCase()}${d.year},\n`;
  str += bibField("author", d.authors);
  str += bibField("title", d.title);
  str += bibField("year", d.year);
  str = str.trim().replace(/,$/, "");
  return str + "\n}";
}
